export default e => {
  e.target.onerror = null;
  e.target.src = 'https://static.thenounproject.com/png/220984-200.png';
};
